import { IconStarRegular, IconStarSolid, Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

import { numberInTenThousandWithFloor } from '@common/utils';
import { ShopInfo } from '@domains/storehome-common';

import { Comment } from '../components/Comment';
import { SelectedCoupon } from '../components/SelectedCoupon';
import { SelectedShopBasicInfo } from '../components/shop-basic-info/SelectedShopBasicInfo';
import { ShopBasicInfoWrapper } from '../components/shop-basic-info/ShopBasicInfo.styled';
import { Thumbnail } from '../components/shop-basic-info/Thumbnail';
import { useShopInformationService } from '../services/useShopInformationService';

interface Props {
  shop_info: ShopInfo;
  is_cover_view: boolean;
}

export const SelectedShopInformationContainer = ({ shop_info, is_cover_view }: Props) => {
  const {
    id,
    title,
    subtitle,
    typical_image_url,
    comment,
    representative_coupon,
    representative_coupon_v2,
    bookmark_count,
    is_saved_shop,
  } = shop_info;

  const { handleBookmarkClick, handleCouponDownloadClick } = useShopInformationService({ shop_info });

  return (
    <Root is_cover={is_cover_view}>
      <InfoWrap>
        <ShopBasicInfoWrapper gap={12}>
          <Thumbnail image_url={typical_image_url} size={46} />
          <SelectedShopBasicInfo name={title?.text || ''} description={subtitle?.text || ''} />
        </ShopBasicInfoWrapper>
        <BookmarkWrap onClick={handleBookmarkClick}>
          {is_saved_shop ? <IconStarSolid color='brandSelected' /> : <IconStarRegular color='iconTertiary' />}
          <BookmarkCount variant='Caption_11_Medium' color='textTertiary' as='span'>
            {numberInTenThousandWithFloor(bookmark_count)}
          </BookmarkCount>
        </BookmarkWrap>
      </InfoWrap>
      {comment && <Comment comment={comment} />}
      <CouponWrapper>
        <SelectedCoupon
          shop_id={id}
          representative_coupon={representative_coupon}
          representative_coupon_v2={representative_coupon_v2}
          onClick={handleCouponDownloadClick}
        />
      </CouponWrapper>
    </Root>
  );
};

const Root = styled.div<{ is_cover: boolean }>`
  position: relative;
  padding: 0 16px 24px;
  z-index: 10;
  background-color: ${vars.color.staticWhite};

  ${({ is_cover }) =>
    is_cover &&
    `
    margin-top: 0;
    padding-top: 32px;
  `}
`;

const InfoWrap = styled.div`
  display: flex;
  gap: 12px;
  justify-content: space-between;
`;

const BookmarkWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 32px;
`;

const BookmarkCount = styled(Text)`
  line-height: 14.4px;
  white-space: nowrap;
`;

const CouponWrapper = styled.div`
  margin-top: 16px;
`;
